<script setup lang="ts">
import { useRouter } from 'vue-router';
import BankingWrapper from '@/application/layouts/ContentWrapper/BankingWrapper.vue';

defineProps<{ category: string }>();

const router = useRouter();

async function onOpenTransaction(e: CustomEvent) {
  const { bankAccessId, bankAccountId, transactionId } = e.detail;
  await router.push(`/banking/${bankAccessId}/account/${bankAccountId}/transaction/${transactionId}`);
}
</script>

<template>
  <BankingWrapper v-slot="{ token, onEmitError }">
    <!-- eslint-disable vue/v-on-event-hyphenation -->
    <ba-budget-analysis-category-transactions
      :token="token"
      :category="category"
      @emitError="(e) => onEmitError(e, 'ba-budget-analysis-category-transactions')"
      @openTransaction="onOpenTransaction"
    />
  </BankingWrapper>
</template>
